import {ActionTypes} from './../../cc-imports'

const Actions = {
    updateDimension: (payload)=> {
        return {
            type: ActionTypes.DIMENSION_CHANGED,
            payload:payload
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/DimensionActions.js